import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GeneralHelper, LoaderService, Message } from "@stdoutsrl/design-kit";
import { RestService } from "@stdoutsrl/design-kit";
import { api } from "../../environments/environment";

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styles: [],
  standalone: false,
})
export class RegistrationComponent implements OnInit {
  constructor(
    private router: Router,
    private message: Message,
    private rest: RestService,
    private loader: LoaderService,
    private general:GeneralHelper
  ) {}

  credentials: any = {};
  showPassword = false;
  acceptPrivacy = false;
  acceptTerms = false;

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const referral = params.get("referral");
    if (referral) {
      this.credentials.referral = referral;
    }
  }

  checkboxTerms(event: any) {
    this.acceptTerms = event.checked;
  }

  checkboxPrivacy(event: any) {
    this.acceptPrivacy = event.checked;
  }

  register() {
    this.loader.on();
    this.rest.post(api.endpoint.register, this.credentials).subscribe({
      next: (value: any) => {
        this.loader.off(true);
        this.message.showMessage("Ti sei registrato con successo", "success");
        // this.rest.setToken(value.access_token);
        this.router.navigate(["login"]);
      },
      error: (value) => {
        this.loader.off(true);
        this.message.showMessage(value.message, "error");
      },
    });
  }

  checkCredentials() {
    return (
      this.credentials.firstName &&
      this.credentials.lastName &&
      this.credentials.email &&
      this.general.isEmailValid(this.credentials.email) && 
      this.credentials.password &&
      this.credentials.confirmPassword &&
      this.credentials.password === this.credentials.confirmPassword
    );
  }

  checkEmail(){
    return this.general.isEmailValid(this.credentials.email)
  }

  backToLogin() {
    this.router.navigate(["/login"]);
  }
  showMessage(status: string, message: string) {
    this.message.showMessage(message, status);
  }
}
